import { ApiBase, ApiResponse } from '../api-base';
import { inject } from 'aurelia';
import { IHttpClient } from '@aurelia/fetch-client';
import { VenueEntity } from './venue-entity';

@inject(IHttpClient)
export class VenuesApi extends ApiBase {

    constructor(http: IHttpClient) {
        super(http);
    }

    public async add(eventId: string, entity: VenueEntity): Promise<VenueEntity> {
        const dto = entity.toDto();
        const response = await this.post(this._baseUrl(eventId), dto);
        return VenueEntity.fromDto(response.content);
    }

    public async update(eventId: string, id: string, entity: VenueEntity): Promise<VenueEntity> {
        const dto = entity.toDto();
        const response = await this.patch(this._baseUrl(eventId) + '/' + id, dto);
        return VenueEntity.fromDto(response.content);
    }

    public async getById(eventId: string, id: string): Promise<VenueEntity> {
        const response = await this.get(this._baseUrl(eventId) + '/' + id);
        return VenueEntity.fromDto(response.content);
    }

    public async listByEventId(eventId: string): Promise<VenueEntity[]> {
        const response = await this.get(this._baseUrl(eventId));
        return VenueEntity.fromDtoArray(response.content);
    }

    public async deleteById(eventId: string, id: string): Promise<ApiResponse> {
        const response = await this.delete(this._baseUrl(eventId) + '/' + id);
        return response.content;
    }
    private _baseUrl(eventId: string): string {
        return `api/events/${eventId}/venues`;
    }
}
